import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PlanoService } from 'src/app/service/plano.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Plano } from './plano';

@Component({
  selector: 'app-plano-consulta',
  templateUrl: './plano-consulta.component.html',
  styleUrls: [
    './plano-shared.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class PlanoConsultaComponent {

  listaPlano: Plano[] = [];
  ordemColunasTabela = ['id', 'nome', 'segmento', 'valorBase', 'taxaAdesao', 'situacao', 'acoes'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  consultaRealizada = false;
  mensagemErros: string[] = [];
  tipoFiltros = ['ID', 'Plano', 'Segmento'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;

  constructor(
    private planoService: PlanoService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  consultar(resetPagina = true) {
    if (resetPagina) this.pagina = 0;
    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.planoService.getById(idFiltro).subscribe(plano => {
        let lista = [plano];
        lista = aplicarFiltrosConsulta<Plano>(lista, this.tipoFiltro, this.parametro, this.situacao, {
          id: (p: Plano) => p.id,
          nome: (p: Plano) => this.tipoFiltro === 'Segmento' ? (p.segmentoNome ?? '') : p.nome,
          ativo: (p: Plano) => p.situacao,
        });
        this.listaPlano = lista;
        this.totalElementos = lista.length;
        this.consultaRealizada = true;
      }, () => this.mensagemErros = ['Plano não encontrado.']);
      return;
    }
    this.planoService.list(this.pagina, this.tamanho).subscribe(response => {
      const filtrados = aplicarFiltrosConsulta<Plano>(response.content ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: (p: Plano) => p.id,
        nome: (p: Plano) => this.tipoFiltro === 'Segmento' ? (p.segmentoNome ?? '') : p.nome,
        ativo: (p: Plano) => p.situacao,
      });
      this.listaPlano = filtrados;
      this.totalElementos = (this.parametro || this.situacao !== null) ? filtrados.length : response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + (errorResponse.error?.message ?? 'Falha ao listar planos')];
    });
  }

  listarPlanos() {
    this.consultar(false);
  }

  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarPlanos();
  }

  novo() {
    this.router.navigate(['/plano/form']);
  }

  editar(id: number) {
    this.router.navigate(['/plano/form', id]);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.planoService.delete(id).subscribe(() => {
      this.snackBar.open('Plano excluído com sucesso!', 'Sucesso', { duration: 2000 });
      this.listarPlanos();
      this.mensagemErros = [];
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }
}
